import { createFileRoute } from '@tanstack/react-router'
import { OnboardingPage } from 'pages/app/onboarding/OnboardingPage'

export const Route = createFileRoute('/_authenticated/app/kom-igang')({
  component: OnboardingPage,
})
